import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 10px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  color: ${({ theme }) => theme.colors.primaryText};
`;

export const Results = styled.div`
  position: absolute;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 4px;
  left: 0;
  right: 0;
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  background: ${({ theme }) => theme.colors.background};
  box-shadow: ${({ theme }) =>
    `0px 5px 13px 0px ${theme.colors.lightLineDivider}`};

  max-height: 120px;
  border-radius: 5px;
  overflow-y: auto;
`;

export const Result = styled(Box)`
  padding: 12px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};

  background-color: ${({ highlighted, theme }) => {
    if (highlighted) {
      return theme.colors.highlights;
    }
    return 'transparent';
  }};

  &:last-child {
    border-bottom: none;
  }
`;
